import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/api-response/api-response.model';
import { SubTodoForCreation } from '../models/subtodos/sub-todo-for-creation.model';
import { SubTodoForUpdation } from '../models/subtodos/sub-todo-for-updation.model';

@Injectable({
  providedIn: 'root'
})
export class SubTodoService {
  private apiUrl = `${environment.apiUrl}/SubTodo`;

  constructor(private http: HttpClient) { }

  addSubTodo(data: SubTodoForCreation): Observable<ApiResponse & { subTodoId?: number }> {
    return this.http.post<ApiResponse & { subTodoId?: number }>(this.apiUrl, data);
  }

  updateSubTodo(data: SubTodoForUpdation): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(this.apiUrl, data);
  }

  deleteSubTodo(subTodoId: number): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(`${this.apiUrl}/${subTodoId}`);
  }

  checkSubTodo(subTodoId: number): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`${this.apiUrl}/check/${subTodoId}`, {});
  }

  uncheckSubTodo(subTodoId: number): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`${this.apiUrl}/uncheck/${subTodoId}`, {});
  }
}
